<template>
    <div class="gray-back" style="padding:.2rem 0 3rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-cell-group>
                <van-cell
                        :value="formData.saiqu.name"
                        title="赛区"
                />
                <van-cell
                        :value="formData.baoming.danwei"
                        title="单位"
                />
                <van-cell
                        :value="formData.baoming.mingcheng"
                        title="队伍名称"
                />
                <van-cell
                        :value="formData.subject_name"
                        title="项目"
                />
                <van-cell title="上传照片" :value="formData.pic.length+'/1'"  v-if="canSubmit">
                    <!--<template slot="icon" >-->
                    <!--<van-icon class="question-icon" name="question-o" @click="onQuestion('heying')"/>-->
                    <!--</template>-->
                </van-cell>
                <div class="row"  v-if="canSubmit">
                    <PicUploader :fileList="formData.pic" :limit="1"
                                 :name="'pic'"></PicUploader>
                </div>
                <div class="operate-desc-left"  v-if="canSubmit">请上传一张照片</div>
                <van-cell title="视频" :value="formData.pic.length+'/1'"  v-if="canSubmit">
                    <!--<template slot="icon" >-->
                    <!--<van-icon class="question-icon" name="question-o" @click="onQuestion('heying')"/>-->
                    <!--</template>-->
                </van-cell>

                <div class="row"  v-if="canSubmit">
                    <VideoUploader :minSize="0" :fileList="formData.video" :limit="1"
                                   @onInputClick="onVideoInputClick"
                              :fileName="formData.baoming.mingcheng+'-'+formData.subject_name"   :name="'video'"></VideoUploader>
                </div>
                <div class="operate-desc-left"  v-if="canSubmit">请上传一段视频</div>
            </van-cell-group>
            <div class="savebtn" v-if="canSubmit">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交</van-button>
            </div>
        </van-form>

        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        height: 36px;
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import VideoUploader from '@/components/picker/VideoUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon,Dialog, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
    import LoginDialog from '@/components/LoginDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Dialog).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep1',
        components: {
            [Field.name]: Field,
            PicUploader,
            VideoUploader,
            CaipanPicker,
            JiaolianPicker,
            LoginDialog
        },
        data: function () {
            return {
                validator,
                loginShow:false,
                canSubmit:false,
                saveLoading:false,
                showCaipanPicker:false,
                showJiaolianPicker:false,
                showNumTypePicker:false,
                numTypeColumns: ['身份证', '护照'],
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                formData: {
                    id:0,
                    baoming:{

                    },
                    saiqu:{

                    },
                    pic: [],
                    video: [
                        {name:"xxxx.mov",
                            save_name:"h5/2020-05-26/1590474953142781.mov",
                            uid:"vc-upload-1590474953142781",
                            url:"https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-26/1590474953142781.mov"}
                    ],
//                            [{name:"选择商户.png",
//                        save_name:"h5/2020-05-11/1589187988243621.png",
//                        uid:"vc-upload-1589187988243621",
//                        url:"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-11/1589187988243621.png"
//                    }],
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.formData.id = this.$route.query.id;
            document.title = '上传视频';
            that.fetch();

            window.rbMessage = function (data) {
                data = JSON.parse(data);
//                alert(data);
                if(data[0] == 'videoUploadSuccess'){
                    that.formData.video = [data[1]];
                }
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            fetch(){
                let that = this;
                that.$api.get('/api/isai/videoDetail', {
                    id : that.formData.id,
                }, (res) => {
                    that.formData = Object.assign(that.formData, res.data);
                    if(res.data.baoming.memberstatus !=6){
                        Toast("报名尚未成功,无法进行操作");
                    }else{
                        that.canSubmit = true;
                    }

                },(res) =>{
                    console.log('没有登录');
                    if (res.code == 401 || res.code==402) {
                        that.loginShow = true
                    }else {
                        Toast(res.msg)
                    }
                })
            },
            onQuestion(){
                console.log('onQuestion')
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {
                    if (that.formData.pic.length == 0) {
                        Toast('请上传照片');
                        return
                    }
                    if (this.formData.video.length==0) {
                        Toast('请上传视频');
                        return
                    }
                }
                that.saveLoading = true;
                that.$api.post('/api/isai/savesubjectvideo', that.formData, (res) => {
                    that.saveLoading = false;

                    appEvent({
                        name: 'saiApplyVideoReload',
                        query: {
                        }
                    });
                    appEvent({
                        name: 'saiApplyDetailReload',
                        query: {
                        }
                    });

                    setTimeout(() =>{
                        rbLink({
                            'name' : 'ISaiApplyVideoList',
                            'query':{
                                id:that.formData.baoming.id,
                            }
                        },'back')
                    },1000)
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onVideoInputClick(){
                let that =this;
                console.log({
                    name:'onVideoInputClick',
                    query:{
                        'mingcheng':this.formData.baoming.mingcheng,
                        'subject_name':this.formData.subject_name,
                    }
                });

                appEvent({
                    name:'onVideoInputClick',
                    query:{
                        'mingcheng':this.formData.baoming.mingcheng,
                        'subject_name':this.formData.subject_name,
                    }
                });
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },

            loginSuccess(res){
                console.log('-------登录成功--------',res);
                this.loginShow = false;
                this.fetch();
            },

            loginCancel(){
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFormUploadVideo.vue?125c4f9a